module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"behavior-instance-tab\">\r\n    <div class=\"\" style=\"float:none;\">\r\n        <div style=\"float:left;\">\r\n            <label>")
    ; __append(escapeFn( text ))
    ; __append("</label>\r\n        </div>\r\n        <div class=\"behavior-instance-close-img\">\r\n            <i class=\"fa pf-close\"></i>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}